export const getFamilyDetailsList = (familyData = {}) => [
  {
    label: "Family Type",
    value: familyData?.family_type || null,
  },
  {
    label: "Father Occupation",
    value: familyData?.father_occupation || null,
  },
  {
    label: "Mother Occupation",
    value: familyData?.mother_occupation || null,
  },
  {
    label: "Sister",
    value: familyData?.num_sisters ??  null,
  },
  {
    label: "Family Status",
    value: familyData?.financial_status || null,
  },
  {
    label: "Father Name",
    value: familyData?.father_name ?? "",
  },
  {
    label: "Mother Name",
    value: familyData?.mother_name ?? "",
  },
  {
    label: "Brother",
    value: familyData?.num_brothers ??  null,
  },
  {
    label: "Married Brother",
    value: familyData?.num_brothers_married ?? null,
  },
  {
    label: "Married Sister",
    value: familyData?.num_sisters_married ?? null,
  },
];
